<template>
  <div class="detail-tips">
    <div class="cate-list">
      <div class="cate-item" v-for="(cate, cateIndex) in detail.cate_tips" :key="cate.id">
        <h2 class="cate-title" @click="toggleCate(cateIndex)">
          <svg class="cate-arrow" :class="{ 'is-collapsed': !isExpanded(cateIndex) }" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9.2" fill="none" stroke="currentColor" stroke-width="1.3"></circle>
            <path d="M6.8 11.8 L10 8.6 L13.2 11.8" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span>{{ cate.cate_name }}</span>
        </h2>
        <div class="tips-list" v-show="isExpanded(cateIndex)">
          <div class="tips-item" v-for="tip in cate.tips">
            <div class="tips-image">
              <img :src="tip.image" alt="">
            </div>
            <div class="tips-container">
              <div class="tips-title">
                <p>Model</p>
                <h3>{{ tip.name }}</h3>
              </div>
              <div class="tips-content">
                <p v-html="tip.content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "detail-tips",
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  data(){
    return {
      // 记录每个分类是否已收起，默认全部展开
      collapsed: {}
    }
  },
  methods: {
    isExpanded(index){
      return this.collapsed[index] !== true
    },
    toggleCate(index){
      this.$set(this.collapsed, index, !this.collapsed[index])
    }
  }
}

</script>

<style scoped>
.detail-tips{
  padding: 0 .3rem .8rem .3rem;
}

.detail-tips .cate-list {

}
.detail-tips .cate-list .cate-item {
  margin-top: 2rem;
}
.detail-tips .cate-list .cate-item:first-child {
  margin-top: 1rem;
}
.detail-tips .cate-list .cate-item h2 {
  font-size: .36rem;
  font-weight: 500;
}
/* 分类名称前的展开/收起图标(参考商品列表页，工作尖模式为黑色) */
.detail-tips .cate-list .cate-item h2.cate-title {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.detail-tips .cate-list .cate-item .cate-arrow {
  flex: none;
  width: .28rem;
  height: .28rem;
  margin-right: .2rem;
  color: #1B1B1B;
  transition: transform .3s;
}
.detail-tips .cate-list .cate-item .cate-arrow.is-collapsed {
  transform: scaleY(-1);
}
.detail-tips .cate-list .cate-item .tips-image {
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .3), 0 0 6px rgba(0, 0, 0, .04);
  overflow: hidden;
  border-radius: 8px;
}
.detail-tips .cate-list .cate-item .tips-image img {
  width: 100%;
}
.detail-tips .cate-list .cate-item .tips-container {
}
.detail-tips .cate-list .cate-item .tips-container .tips-title {
  font-size: .28rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: .4rem 0 .3rem 0;
  border-bottom: 1px solid #B5B5B5;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title p {
  color: #7D7D7D;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title h3 {
  font-weight: 500;
  margin-left: .23rem;
  color: #1C1B1B;
}

.detail-tips .cate-list .cate-item .tips-container .tips-content {
  color: #7D7D7D;
  font-size: .26rem;
  line-height: 2;
  margin-top: .3rem;
}
.detail-tips .cate-list .cate-item .tips-list .tips-item {
  margin-top: .8rem;
}
</style>

<style>
.detail-tips .cate-list .cate-item .tips-container .tips-content p {
  font-size: .26rem!important;
  white-space: pre-wrap;
}
</style>
